export default "__VITE_ASSET__D60ui2Vb__"